import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import { getPlanData } from "views/User/views/Plans/helpers/plans"

import PlanIcon from "./PlanIcon"

import gridStyles from "../../../components/Plans.module.css"

const PricingHeader = ({ name, type, displayName }) => {
  const { t: translate } = useTranslate()
  const { description } = getPlanData(name, type)

  return (
    <div
      className={`${gridStyles.pricingHeader} flex-container f-a-center f-d-col m-t-30`}
    >
      <PlanIcon name={name} type={type} />
      <p className={`${gridStyles.pricingTitle} fs-24 w700 no-m`}>
        {translate(displayName)}
      </p>
      <p
        className={`${gridStyles.pricingSubtitle} fs-16 textCenter w300 m-t-25`}
      >
        {translate(description)}
      </p>
    </div>
  )
}

PricingHeader.propTypes = {
  name: PropTypes.string,
  displayName: PropTypes.string,
  type: PropTypes.string,
}
PricingHeader.defaultProps = { name: "", displayName: "", type: "" }

export default PricingHeader
